export default __webpack_public_path__ + "static/media/White Hand Deathgloves.ccd77981.jpg";